import {
  FETCH_CURRENT_ORDER_START,
  FETCH_CURRENT_ORDER_SUCCESS,
  FETCH_CURRENT_ORDER_FAILURE,
  FETCH_GOODS_START,
  FETCH_GOODS_SUCCESS,
  FETCH_GOODS_FAILURE
} from '../actionTypes';
import * as api from '../api';

export const fetchOrderAndGoods = () => async dispatch => {
  dispatch({ type: FETCH_CURRENT_ORDER_START });

  api
    .getCurrentOrder()
    .then(data => {
      dispatch({
        type: FETCH_CURRENT_ORDER_SUCCESS,
        payload: data
      });
      dispatch({ type: FETCH_GOODS_START });
      api
        .getGoods()
        .then(dataGoods => {
          dispatch({
            type: FETCH_GOODS_SUCCESS,
            payload: dataGoods.goods
          });
        })
        .catch(err => {
          dispatch({
            type: FETCH_GOODS_FAILURE,
            payload: err,
            error: true
          });
        });
    })
    .catch(err => {
      dispatch({
        type: FETCH_CURRENT_ORDER_FAILURE,
        payload: err,
        error: true
      });
    });
};
